import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const InviteRedirect: React.FC = () => {
  const { inviteId } = useParams<{ inviteId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (inviteId) {
      sessionStorage.setItem('pendingInviteId', inviteId);
      navigate('/signin', { replace: true });
    }
  }, [inviteId, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-zinc-600">Redirecting to sign in...</p>
      </div>
    </div>
  );
};

export default InviteRedirect;
